const React = require('react')
const DarkContextWrapper = require('./src/context/darkMode').default
const ScrollContextWrapper = require('./src/context/scrollContext').default
const DarkModeWrapper = require('./src/components/darkModeWrapper').default
exports.wrapRootElement = ({ element }) => {
    return (
        <ScrollContextWrapper>
            <DarkContextWrapper>
                <DarkModeWrapper>
                    {element}
                </DarkModeWrapper>
            </DarkContextWrapper>
        </ScrollContextWrapper>

    )
}



